export default "__VITE_ASSET__Cmi2CQNC__"